import React from 'react';
import FraudAlertsSection from '../../../sections/AdminDashboard/SecurityFraud/FraudAlerts';

const FraudAlerts = () => {
  return <FraudAlertsSection />;
};

export default FraudAlerts;

